// extracted by mini-css-extract-plugin
export default {"navtab":"NavTab_navtab__bK5bx","tab":"NavTab_tab__iRd1U","active":"NavTab_active__ioAc5","container":"NavTab_container__YZVxV","content":"NavTab_content__AjYWv"};